import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Layer, Image } from "react-konva";
import Konva from "konva";
import {
    backgroundMoved,
    backgroundTransformed, newBackgroundRequestedClick, setBackgroundScale,
} from "../../actions/background-actions";
import { setImgPdfPageSizes, setPdfPageSizes } from "../../actions/pdf-actions";
import { resetPositionScale } from "../../actions/viewport-actions";
import { startRescaleMultibeds } from "../../actions/multi-bed-actions";

class Background extends PureComponent{
    componentDidUpdate( prevProps, prevState ) {

        /* if edit is active, add transformer */
        if (this.props.bgEdit) {
            // Save bgImg.width and bgImg.height on Redux for later use
            if (
                this.props.bgImg &&
                this.props.bgImg.height &&
                this.props.bgImg.width &&
                this.props.bgImg !== prevProps.bgImg
            ) {
                this.props.resetPositionScale();
                this.props.setImgPdfPageSizes({
                    height: this.props.bgImg.height,
                    width: this.props.bgImg.width,
                });
                this.props.setBackgroundScale(this.props.scalePixels);
            }

            /* get stage and layer references */
            let stage = this.imageNode.getStage();
            let layer = this.imageNode.getLayer();
            /* destroy any existing transformers */
            stage.find("Transformer").destroy();
            /* create transformer */

            // const anchors = ( !this.isMultiBed() )
            const anchors = [
                "top-left",
                "top-right",
                "bottom-left",
                "bottom-right",
            ];

            let transformer = new Konva.Transformer({
                node: this.imageNode,
                enabledAnchors: anchors,
            });
            // transformer.rotateEnabled(!this.isMultiBed());
            layer.add(transformer);
            layer.batchDraw();

            if (this.props.newBackgroundRequestedByClick && this.isMultiBed())
                setTimeout(() => {
                    setTimeout(() => {
                        this.props.startRescaleMultibeds(true);
                        this.props.newBackgroundRequestedClick(false);
                    });
                });

        } else {
            /* destroy the transformer */
            this.imageNode
                .getStage()
                .find("Transformer")
                .destroy();
        }
    }

    handleOnDragEnd() {
        this.props.backgroundMoved({
            x: this.imageNode.x(),
            y: this.imageNode.y(),
        });
    }

    handleOnTransformEnd() {
        this.props.backgroundTransformed({
            x: this.imageNode.x(),
            y: this.imageNode.y(),
            rotation: this.imageNode.rotation(),
            scaleX: this.imageNode.scaleX(),
            scaleY: this.imageNode.scaleY(),
        });

        // set sizes for PDF and image
        let width, height;
        width = this.props.pdfPageSizes.ptWidth * this.imageNode.scaleX();
        height = this.props.pdfPageSizes.ptHeight * this.imageNode.scaleY();
        const newSizePDF = {
            ptWidth: width,
            ptHeight: height,
            inWidth: parseFloat(( width / 72 ).toFixed(2)),
            inHeight: parseFloat(( height / 72 ).toFixed(2)),
            mmWidth: parseFloat(( width / 2.835 ).toFixed(2)),
            mmHeight: parseFloat(( height / 2.835 ).toFixed(2)),
        };
        this.props.setPdfPageSizes(newSizePDF);
        this.props.setImgPdfPageSizes({ height: newSizePDF.ptHeight, width: newSizePDF.ptWidth });
    }

    handleOnMouseEnter() {
        if (this.props.bgEdit && !this.props.isPanning) {
            this.imageNode.getStage().container().style.cursor = "move";
        }

    }

    handleOnMouseLeave() {
        if (this.props.bgEdit && !this.props.isPanning) {
            this.imageNode.getStage().container().style.cursor = "default";
        }
    }

    isMultiBed() {
        return this.props.project
        && this.props.project.project
        && this.props.project.project.isMultiBedProject
            ? this.props.project.project.isMultiBedProject
            : false;
    }

    render() {
        /* if image is not present, render empty image */
        if (!this.props.bgImg) {
            return (
                <Layer>
                    <Image
                        visible={false}
                        ref={node => {
                            this.imageNode = node;
                        }}
                    />
                </Layer>
            );
        }

        const isMultibed = this.isMultiBed();
        /* if image is present, display */
        return (
            <Layer>
                <Image
                    // id="background"
                    id="background"
                    visible={this.props.bgShow}
                    image={this.props.bgImg}
                    x={this.props.x}
                    y={this.props.y}
                    scaleX={this.props.scaleX}
                    scaleY={this.props.scaleY}
                    rotation={this.props.rotation}
                    // draggable={this.props.bgEdit && !isMultibed}
                    draggable={this.props.bgEdit}
                    ref={node => {
                        this.imageNode = node;
                    }}
                    onDragEnd={() => this.handleOnDragEnd()}
                    onTransformEnd={() => this.handleOnTransformEnd()}
                    onMouseEnter={() => this.handleOnMouseEnter()}
                    onMouseLeave={() => this.handleOnMouseLeave()}
                />
            </Layer>
        );
    }
}

const mapStateToProps = state => {
    return {
        project: state.project,

        bgEdit: state.drawingToolbar.bgEdit,
        bgShow: state.background.bgShow,
        bgImg: state.background.bgImg,
        bgAppliedScale: state.background.appliedScale,

        x: state.background.x,
        y: state.background.y,
        scaleX: state.background.scaleX,
        scaleY: state.background.scaleY,
        rotation: state.background.rotation,
        setCount: state.background.setCount,
        newBackgroundRequestedByClick: state.background.newBackgroundRequestedByClick,

        isPanning: state.viewport.isPanning,

        pdfPageSizes: state.pdf.pdfPageSizes,
        scalePixels: state.globals.scalePixels,
        rescaleMultibeds: state.multiBed.rescaleMultibeds,
    };
};

const mapDispatchToProps = {
    backgroundMoved,
    setBackgroundScale,
    backgroundTransformed,
    setImgPdfPageSizes,
    setPdfPageSizes,
    resetPositionScale,
    startRescaleMultibeds,
    newBackgroundRequestedClick,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Background);



// WEBPACK FOOTER //
// ./src/components/Drawings/background.js